export default __webpack_public_path__ + "rentmate-1ab14b83df929f9bfaf8017b7a251764.bundle.png";